import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';
import { useCMSPageField } from '@/cms/fields';
import { createParticipantsAllocatedEvent } from '@/domain/prices/analytics/index';
import { usePrices } from '@/domain/prices/prices/hooks';
import { formatParticipantDistributionToGA4Result } from '@/scopes/search/search/domain/analytics/mappers';
import { usePricesStore } from '@/infrastructure/prices/usePricesStore';
import { useRoomSelector } from '../rooms/hooks';

import * as React from 'react';

export function useSendParticipantsAllocated() {
  const { sendEvent } = useAnalytics();
  const pricetableAnalytics = useCMSPageField('PDP.pricetable.analytics');
  const { prices } = usePrices();
  const { allRoomsSelected, selectedRooms } = useRoomSelector();

  const { selectedPriceId, filterSelection } = usePricesStore();
  const { TransportType, Participants } = filterSelection;

  const sendParticipantsAllocatedEvent = React.useCallback(() => {
    if (!pricetableAnalytics) return;

    const { accoId, accoName, accoBrand, breadcrumbs, stars, rating, cityId, regionId, countryId } =
      pricetableAnalytics;

    const selectedPrice = prices.find((price) => price.id === selectedPriceId);

    const { distribution: partyComposition, total: totalGuests } = formatParticipantDistributionToGA4Result(
      Participants || []
    );

    sendEvent(
      createParticipantsAllocatedEvent({
        accoId: `${accoId}`,
        accoBrand,
        rating,
        accoName,
        breadcrumbs,
        accoStars: stars,
        transportType: TransportType ?? '',
        boardType: selectedPrice?.mealplan ?? '',
        duration: selectedPrice?.duration ? selectedPrice.duration.toString() : '',
        partyComposition,
        totalGuests,
        cityId,
        regionId,
        countryId,
        departureDate: selectedPrice?.departureDate ?? '',
        price: selectedPrice?.minPricePerPerson ?? 0,
        roomType: selectedRooms.map((room) => room.name).join(' - '),
        campaignId: selectedPrice?.bullet?.code ?? '',
      })
    );
  }, [Participants, TransportType, prices, pricetableAnalytics, selectedPriceId, selectedRooms, sendEvent]);

  React.useEffect(() => {
    if (allRoomsSelected) {
      sendParticipantsAllocatedEvent();
    }
  }, [allRoomsSelected]);
}
